export default function mapPropsToValues() {
  return {
    code: "",
  };
}
